import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import AppBoard from "@/components/AppBoard";
import HomeSponsors from "@/components/HomeSponsors";

/**
 * Two products, one home. Sponsors (the marketplace) is the default tab; the
 * original likes-first apps crowd board keeps living under the Apps tab and
 * stays reachable at /?tab=apps.
 */
export default function Home() {
    const [params, setParams] = useSearchParams();
    const tab = params.get("tab") === "apps" ? "apps" : "sponsors";

    const onTab = (value) => {
        setParams(value === "sponsors" ? {} : { tab: value }, { replace: true });
    };

    return (
        <div>
            <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-6 relative z-10">
                <Tabs value={tab} onValueChange={onTab}>
                    <TabsList className="bg-surface-1 h-11 p-1" data-testid="home-tabs">
                        <TabsTrigger
                            value="sponsors"
                            data-testid="home-tab-sponsors"
                            className="px-5 py-2 text-sm data-[state=active]:bg-card"
                        >
                            Sponsors
                        </TabsTrigger>
                        <TabsTrigger
                            value="apps"
                            data-testid="home-tab-apps"
                            className="px-5 py-2 text-sm data-[state=active]:bg-card"
                        >
                            Apps
                        </TabsTrigger>
                    </TabsList>
                    <TabsContent value="sponsors" className="mt-0">
                        <HomeSponsors />
                    </TabsContent>
                    <TabsContent value="apps" className="mt-0">
                        <AppBoard />
                    </TabsContent>
                </Tabs>
            </div>
        </div>
    );
}
